import React from 'react';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import './styles/microApp.css';
import Header from './microapp/Header';
import QueueWait from "./microapp/QueueWait";
import PatientVisitInstructions from "./microapp/PatientVisitInstructions";
import QueueVisitTriage from "./microapp/QueueVisitTriage";
import Calendar from "./microapp/Calendar";

function MicroApp({locale, setLocale, microApp, navigation, width}) {

    return (
        <>
            <Header
                locale={locale}
                setLocale={setLocale}
                microApp={microApp}
                width={width}
            />
            {navigation.page === 'queueWait' &&
                <QueueWait
                    locale={locale}
                    microApp={microApp}
                    width={width}
                />
            }
            {navigation.page === 'patientVisitInstructions' &&
                <PatientVisitInstructions
                    locale={locale}
                    microApp={microApp}
                    width={width}
                />
            }
            {navigation.page === 'queueVisitTriage' &&
                <QueueVisitTriage
                    locale={locale}
                    microApp={microApp}
                    width={width}
                />
            }
            {navigation.page === 'calendar' &&
                <Calendar
                    locale={locale}
                    microApp={microApp}
                    width={width}
                />
            }
        </>
    );
}

export default MicroApp;
